import {useState, useCallback} from 'react'
import type {SelectedAgent} from '../types/session'
import {useLocalStorageCache} from './useLocalStorageCache'

const LAST_SELECTED_AGENT_KEY = 'AGENT_SESSIONS_LAST_SELECTED_AGENT'

/**
 * Hook to manage the last selected agent with local storage persistence.
 * Returns the current selected agent and a setter that also persists to local storage.
 */
export function useLastSelectedAgent(): [SelectedAgent, (agent: SelectedAgent) => void] {
  const {value: initialValue, setValue: persistToStorage} = useLocalStorageCache<SelectedAgent>(LAST_SELECTED_AGENT_KEY)

  const [selectedAgentState, setSelectedAgentState] = useState<SelectedAgent>(() => initialValue ?? {})

  const setSelectedAgent = useCallback(
    (agent: SelectedAgent) => {
      setSelectedAgentState(agent)
      persistToStorage(agent)
    },
    [persistToStorage],
  )

  return [selectedAgentState, setSelectedAgent]
}
